import * as React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { RaisedButton, TextField } from 'material-ui';
import styled from 'styled-components';

import DateRangePicker from 'common/components/DateRangePicker';
import DateRange from 'common/domain/DateRange';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import { getStation, getToken } from '../authentication/session/selectors/sessionSelectors';
import Page from '../../components/page/Page';
import CampaignAPI from './services/CampaignAPI';

const Form = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
`;

const Row = styled.div`
  display: flex;
  width: ${({ theme: { V2 } }) => V2.metrics.breakpoints.small}px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ theme: { V2 } }) => V2.metrics.margin.normal}px;
`;

type State = {
  campaignName: string,
  campaignDates: DateRange
}

type Props = {
  t: any,
  theme: object,
  token: string,
  callSign: string,
  actions: {
    openSnackbar: (type: string, message: string) => mixed;
  }
}

class CreateDemoCampaignForm extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      campaignName: '',
      campaignDates: DateRange.nextNWeeks(1),
    };
  }

  onNameChange = ({ target }) => {
    this.setState({ campaignName: target.value });
  };

  onDateRangeChange = (dates) => {
    this.setState({ campaignDates: new DateRange(dates) });
  };

  onSubmit = async () => {
    const { actions, t, token, callSign } = this.props;
    const { campaignName, campaignDates } = this.state;
    try {
      await CampaignAPI.createDemoCampaign(token, callSign, campaignName, campaignDates);
      actions.openSnackbar('message', t('demoCampaignCreatedSuccessfully'));
    } catch (e) {
      actions.openSnackbar('error', t('couldNotCreateDemoCampaign'));
    }
  };

  render() {
    const { t } = this.props;
    const { campaignName, campaignDates } = this.state;
    return (
      <Page useThemeV2 title={t('createDemoCampaign')}>
        <Form>
          <Row>
            <div>{t('demoCampaignTitle')}:</div>
            <TextField
              autoFocus
              id={'campaignNameTextField'}
              key={'campaignNameTextField'}
              placeholder={t('enterCampaignTitle')}
              onChange={this.onNameChange}
              value={campaignName}
            />
          </Row>

          <Row>
            <div>{t('demoCampaignDates')}:</div>
            <DateRangePicker
              weekOnly
              fontSize={({ theme: { V2 } }) => V2.fonts.h3.size}
              from={campaignDates.from}
              to={campaignDates.to}
              onDateRangeChange={this.onDateRangeChange}
            />
          </Row>

          <Row style={{ justifyContent: 'center' }}>
            <RaisedButton
              primary
              label="Create"
              onClick={this.onSubmit}
            />
          </Row>
        </Form>
      </Page>
    );
  }
}

function mapStateToProps(state) {
  return {
    token: getToken(state),
    callSign: getStation(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({
      openSnackbar,
    }, dispatch),
  };
}

export default translate('campaigns')(connect(mapStateToProps, mapDispatchToProps)(CreateDemoCampaignForm));



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/CreateDemoCampaignForm.js